import { getColor } from 'utils';
import styled from 'styled-components';

export const CanvasContainer = styled('div')`
  position: relative;
  width: 100vw;
  height: 100dvh;
  overflow: hidden;
`;

export const ActionButtons = styled('div')`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 3rem;
  width: 100%;
`;

export const ActionButton = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: ${props => getColor(props, 'accent')};
  box-shadow: 0 0 0.25rem ${props => getColor(props, 'onPrimary')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => getColor(props, 'accentHover')};
  }
`;

export const ButtonContainer = styled('div')`
  display: inline-flex;
  gap: 0.5rem;
  width: fit-content;
`;

